import React, { useEffect, useId, useState } from "react";
import { createPortal } from "react-dom";

import { dataTrigger } from "@/analytics";
import { Button } from "@/ui/Button/Button";
import { useAuth } from "@/store/authStore";
import { updateMySubscription } from "@/api/subscriptions";

import cls from "./styles.module.scss";

export function CancelSubscription() {
  const titleId = useId();

  const me = useAuth((s) => s.me);
  const setMe = useAuth((s) => s.setMe);

  const isActive = Boolean(me?.subscription?.is_active);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const close = () => {
    if (loading) return;
    setOpen(false);
  };

  const openModal = () => {
    if (!isActive) return;
    setOpen(true);
  };

  const confirm = async () => {
    if (loading) return;

    try {
      setLoading(true);
      await updateMySubscription({ auto_renew: false });

      if (me?.subscription) {
        setMe({
          ...me,
          subscription: {
            ...me.subscription,
            auto_renew: false,
          },
        });
      }

      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") close();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, loading]);

  if (!isActive) return null;

  return (
    <>
      <button
        type="button"
        className={cls.cancelLink}
        onClick={openModal}
        {...dataTrigger("bkn.main.cancel_subscription")}
      >
        Отменить подписку
      </button>

      {open &&
        createPortal(
          <div className={cls.overlay} role="presentation" onMouseDown={close}>
            <div
              className={cls.modal}
              role="dialog"
              aria-modal="true"
              aria-labelledby={titleId}
              onMouseDown={(e) => e.stopPropagation()}
            >
              <div className={cls.head}>
                <h2 id={titleId} className={cls.title}>
                  Отменить подписку?
                </h2>
                <p className={cls.subtitle}>
                  Доступ останется до конца оплаченного периода. Продление будет
                  отключено.
                </p>
              </div>

              <div className={cls.actions}>
                <Button
                  variant="primary"
                  size="md"
                  onClick={close}
                  disabled={loading}
                  {...dataTrigger("bkn.main.cancel_keep")}
                >
                  Не отменять
                </Button>

                <Button
                  variant="secondary"
                  size="md"
                  onClick={confirm}
                  disabled={loading}
                  {...dataTrigger("bkn.main.cancel_confirm")}
                >
                  {loading ? "Отменяем..." : "Отменить"}
                </Button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}
